export default __webpack_public_path__ + "static/media/kitchen.d8d69616.jpg";